import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { usePropertyData } from '../../../../hooks/usePropertyData';

// Importazione dei componenti modulari
import PropertyBasicInfoSection from '../components/PropertyBasicInfoSection';
import PropertyLocationSection from '../components/PropertyLocationSection';
import PropertyFeaturesSection from '../components/PropertyFeaturesSection';
import DescriptionSection from '../sections/DescriptionSection';
import StrengthsSection from '../sections/StrengthsSection';
import FeaturesSection from '../sections/FeaturesSection';
import DocumentsSection from '../sections/DocumentsSection';
import ImagesSection from '../sections/ImagesSection';

interface MainInfoTabProps {
  propertyId?: string;
}

const MainInfoTab: React.FC<MainInfoTabProps> = ({ propertyId }) => {
  const formContext = useFormContext(); // Verifica che il context sia disponibile
  const { loading } = usePropertyData();
  const isEditing = Boolean(propertyId);

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
        <p className="mt-2 text-gray-600">Caricamento dati...</p>
      </div>
    );
  }

  return (
    <>
      {/* Sezioni principali dell'immobile, ora modularizzate */}
      <PropertyBasicInfoSection />
      <PropertyLocationSection />
      <PropertyFeaturesSection />

      {/* Altre sezioni già esistenti */}
      <DescriptionSection />
      <StrengthsSection />
      <FeaturesSection />
      <DocumentsSection propertyId={propertyId} isEditing={isEditing} />
      <ImagesSection propertyId={propertyId} isEditing={isEditing} />
    </>
  );
};

export default memo(MainInfoTab);